<template>
  <el-drawer :visible.sync="currentValue" class="quick-dialog" @open="openView" :modal="false">
    <div class="quick-box" v-loading="loading">
      <div class="quick-box--header">
        <div class="quick-box--header_left">
          <i class="iconfont iconicon_quick_access"></i>
          <span>快速访问</span>
        </div>
        <i class="iconfont iconicon_develop activeIconHover quick-box--header_right" @click="currentValue = false"></i>
      </div>
      <div class="quick-box--content">
        <div class="quick-box--tap" :class="{'is-show': showStar}">
          <div class="quick-box--tap_header">
            <span class="activeIconHover" @click="handleVisible('showStar')">
              <i class="iconfont iconicon_arrow_task current"></i>
            </span>
            <span>星标项目</span>
          </div>
          <div class="quick-box--tap_content">
            <Nothing width="130px" v-if="startResult && startResult.length === 0"></Nothing>
            <vuedraggable v-else class="grid-css"  handle=".task-drag-box-icon" element="div" v-bind="dragOptions()"  :list="startResult" @update="end" @add="end">
              <ProjectItem v-for="item in startResult" :data-id="item.project_id" :key="item.project_id" :projectInfo="item" @starSuccess="starSuccess" @click.native="openProject(item)" :disabled="!item.permissions"></ProjectItem>
            </vuedraggable>
          </div>
        </div>
        <div class="quick-box--tap" :class="{'is-show': showBefore}">
          <div class="quick-box--tap_header">
            <span class="activeIconHover" @click="handleVisible('showBefore')">
              <i class="iconfont iconicon_arrow_task current"></i>
            </span>
            <span>最近更新项目</span>
          </div>
          <div class="quick-box--tap_content">
            <div class="quick-box--tap_cell" v-for="(item) in beforeResult" :key="item.project_id" @click="openProject(item)">
              <div class="cell-left">
                <toolTip :title="item.title" :maxWidth="'80%'">{{item.title}}</toolTip>
                <div class="task-msgcount-super" v-if="item.msgcount">{{item.msgcount > 100 ? '99+' : item.msgcount}}</div>
              </div>
              <div class="cell-right">
                <i class="iconfont star iconicon_following" v-if="item.project_mark_star && item.project_mark_star.is_mark"></i>
                <span>{{item.completed_number_of_tasks}} <a> / {{item.total_number_of_tasks}}</a></span>
              </div>
            </div>
             <Nothing width="130px" v-if="beforeResult && beforeResult.length === 0"></Nothing>
          </div>
        </div>
        <div class="quick-box--tap" :class="{'is-show': showHistory}">
          <div class="quick-box--tap_header">
            <span class="activeIconHover" @click="handleVisible('showHistory')">
              <i class="iconfont iconicon_arrow_task current"></i>
            </span>
            <span>最近访问项目</span>
          </div>
          <div class="quick-box--tap_content">
            <div class="quick-box--tap_cell" v-for="(item) in historyResult" :key="item.project_id" @click="openProject(item)">
              <div class="cell-left">
                <toolTip :title="item.title" :maxWidth="'80%'">{{item.title}}</toolTip>
                <div class="task-msgcount-super" v-if="item.msgcount">{{item.msgcount > 100 ? '99+' : item.msgcount}}</div>
              </div>
              <div class="cell-right">
                <i class="iconfont star iconicon_following" v-if="item.project_mark_star && item.project_mark_star.is_mark"></i>
                <span>{{item.completed_number_of_tasks}} <a> / {{item.total_number_of_tasks}}</a></span>
              </div>
            </div>
            <Nothing width="130px" v-if="historyResult && historyResult.length === 0"></Nothing>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import api from '@/services/api/home/home'
import ProjectItem from '../myProject/project/projectItem'
import Nothing from '@/components/nothing'
import vuedraggable from 'vuedraggable'
export default {
  props: ['value'],
  components: {
    ProjectItem,
    Nothing,
    vuedraggable
  },
  data() {
    return {
      showStar: false,
      showBefore: false,
      showHistory: false,
      startResult: [],
      historyResult: [],
      beforeResult: [],
      loading: false
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
  },
  methods: {
    openView() {
      this.init()
    },
    handleVisible(key) {
      this[key] = !this[key]
    },
    async init() {
      this.loading = true
      try {
        this.startResult = (await api.getprojectMarkStarList({page: 1, number: 9999})).data
        this.historyResult = (await api.getProjectBrowseHistoryList({page: 1, number: 9999})).data
        this.beforeResult = (await api.getRecentUpdateProjectList({page: 1, number: 9999})).data
      } catch (error) {

      }
      this.loading = false
    },
    openProject(item) {
      this.$router.push(`/task?projectId=${item.project_id}&isTabShow=true`)
    },
    async starSuccess() {
      this.startResult = (await api.getprojectMarkStarList({page: 1, number: 9999})).data
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'list'
      }
    },
    async end(event) {
      let project_id = event.item.dataset.id * 1;
      let index = this.startResult.findIndex(res => res.project_id == project_id)
      let previous_project_id = index - 1 < 0 ? 0 : this.startResult[event.newIndex - 1].project_id
      let params = {
        project_id,
        previous_project_id,
      };
      await api.updateProjectMarkStarSort(params)
      this.$message({
        message: '修改成功',
        type: 'success',
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgba(231, 232, 237, 0.6);
  .quick-box--tap:not(:first-child) {
    // margin-top: 16px;
  }
  .quick-box--header {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
  }
  .quick-box--header_left {
    font-size: 16px;
    font-weight: bold;
    i {
      font-weight: 400;
      color: #FFBE23;
      margin-right: 10px;
    }
  }
  .quick-box--header_right {
    transform: rotate(180deg);
    color: rgba(32, 32, 32, 0.6);
  }
  .quick-box--content {
    flex: 1;
    height: 0;
    overflow: overlay;
    overflow-x: hidden;
    padding: 0 32px;
    padding-bottom: 32px;
    &::-webkit-scrollbar-track-piece {
      background-color: #ECEDF0;
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 8px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 0;
      background-color: #C8CBD3;
      &:active, &:hover {
        background-color: #9199A7;
      }
    }
  }
  .quick-box--tap_header {
    height: 62px;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid rgba(231, 232, 237, 0.60);
    font-weight: bold;
    i {
      // font-weight: 400;
      color: #848D9B;
      transition: all .3s;
      font-size: 14px;
    }
    span:first-child {
      margin-right: 4px;
    }
  }
  .quick-box--tap_content {
    position: relative;
    margin-bottom: 24px;
    /deep/ {
      .nothing-box {
        position: relative;
        transform: translate(-50%,0);
        margin-top: 20px;
        margin-bottom: -20px;
      }
    }
  }
  .grid-css {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-column-gap: 16px;
    grid-row-gap: 20px;
    align-items: flex-start;
    padding-top: 20px;
  }
  .quick-box--tap_star {
    height: 102px;
    width: 250px;
    box-shadow: 0px 2px 4px 0px rgba(13,31,60,0.08);
    border-radius: 8px;
    border: 1px solid rgba(231,232,237,0.6);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .3s;
    &:hover {
      box-shadow: 0px 6px 16px 0px rgba(58,73,96,0.27);
    }
    .star-header {
      display: flex;
      align-items: center;
      span:first-child {
        font-size: 16px;
        font-weight: bold;
      }
      span:last-child {
        font-size: 12px;
        color: rgba(58, 73, 96, 0.80);
        padding-left: 8px;
        flex-shrink: 0;
        a {
          color: rgba(13, 31, 60, 0.4);
        }
      }
    }
    .star-footer {
      display: flex;
      justify-content: space-between;
    }
  }
  .is-show {
    height: 63px;
    overflow: hidden;
    .current {
      transform: rotate(-90deg);
    }
  }
  .quick-box--tap_cell {
    height: 54px;
    border-bottom: 1px solid rgba(231, 232, 237, 0.60);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    padding: 0 24px;
    &:hover {
      background-color: rgba(32, 32, 32, 0.04);
    }
    &:active {
      background-color: #EAEBEC;
    }
    .cell-left {
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
    }
    .cell-right {
      font-size: 12px;
      color: rgba(58, 73, 96, 0.80);
      padding-left: 8px;
      flex-shrink: 0;
      a {
        color: rgba(13, 31, 60, 0.4);
      }
      i {
        margin-right: 6px;
      }
      span {
        display: inline-block;
        min-width: 60px;
        text-align: right;
      }
    }
  }
  .star {
    color:#FFBE23;
  }
  .task-msgcount-super {
    position: initial;
    margin-left: 8px;
    flex-shrink: 0;
  }
}
.quick-dialog {
  /deep/ {
    .el-drawer {
      width: 580px !important;
    }
    .el-drawer__body {
      padding:0;
    }
    #el-drawer__title {
      display: none;
    }
    .nothing-box .tip {
      margin-bottom: 0;
    }
  }
}

</style>
